// gating-config.js — single source of truth for gating exemptions.
//
// Some folders/stages are SELF-ASSESSMENT and must be invisible to gating:
// they never block a downstream gate, and their progress is never counted
// toward unlocking later content. iOS canon implements this as a literal
// id exclusion on the gate's "are all preceding items complete?" test:
//
//   AND ii.item_id != 143095
//
// in BOTH of the only two sites that touch it (verified `grep -rn 143095`
// returns only these, KFE-4.0-App, read 2026-06-15):
//   • KFEDatabaseManager.m:579  (+ handleGatesAndMetersCompletionForItemID:)
//   • StagesViewController.m:124 (stage-level gate opening on the stage list)
//
// Stefan's in-source comment states the intent verbatim:
//   "增加了 AND ii.item_id != 143095 的检测，以排除 Stage 1（Item ID是143095）"
//   — "added the AND ii.item_id != 143095 check, to exclude Stage 1."
//
// We deliberately diverge MILDLY from iOS's hardcoded literal (approved by
// Chris 2026-06-15): the runtime honours an `excludeFromGating` content flag
// (preferred — a CMS/author can set it with no code change) and falls back to
// this set, so a content-id change is a one-line edit here rather than a
// magic number scattered inline. Web id for Stage 1 is `stage_143095`. Brief 150.

/**
 * Folder/stage ids exempt from gating (self-assessment stages). Mirrors iOS's
 * `AND ii.item_id != 143095` exclusion; flag-driven for id-change robustness.
 * @type {Set<string>}
 */
export const GATING_EXEMPT_FOLDER_IDS = new Set(["stage_143095"]);

/**
 * Is this node id exempt from gating? Combines the content flag (preferred,
 * survives a corpus regen and is author-editable) with the static fallback set
 * (defensive, works on pre-regeneration JSON).
 *
 * @param {string|number|undefined|null} id
 * @param {boolean} [excludeFromGatingFlag]  the content `excludeFromGating` field
 * @returns {boolean}
 */
export function isGatingExemptId(id, excludeFromGatingFlag) {
  return excludeFromGatingFlag === true || GATING_EXEMPT_FOLDER_IDS.has(String(id));
}
